import { render } from "./ReleaseMain.vue?vue&type=template&id=3ade17b8&scoped=true&ts=true"
import script from "./ReleaseMain.vue?vue&type=script&lang=ts"
export * from "./ReleaseMain.vue?vue&type=script&lang=ts"

import "./ReleaseMain.vue?vue&type=style&index=0&id=3ade17b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ade17b8"]])

export default __exports__